module.exports = __webpack_public_path__ + "media/images/icons/person-b8a0e3843e44f77f1d92ef7a04030c56.svg";